import PageHero from "@/components/PageHero";
import { Link } from "react-router-dom";

export default function StubPage({ eyebrow, title, subtitle, sections = [] }) {
  return (
    <div data-testid={`stub-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <PageHero eyebrow={eyebrow} title={title} subtitle={subtitle} />
      <section className="section-spacing nkf-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 items-stretch">
          {sections.map((s, i) => (
            <div key={i} className="federation-card bg-white border border-slate-200 rounded-md p-6 flex flex-col h-full">
              {s.icon && <s.icon className="h-7 w-7 text-nkf-red" />}
              <h3 className="font-display text-xl text-nkf-blue mt-4">{s.title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">{s.body}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 p-6 md:p-8 bg-nkf-blue text-white rounded-md flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-gold">Get Involved</div>
            <div className="font-display text-2xl mt-1">Register or contact the federation for more information.</div>
          </div>
          <div className="flex gap-3">
            <Link to="/register" className="bg-nkf-gold text-nkf-navy px-5 py-2.5 rounded text-sm uppercase tracking-widest font-bold hover:bg-white">Register</Link>
            <Link to="/contact" className="border border-white/30 text-white px-5 py-2.5 rounded text-sm uppercase tracking-widest font-semibold hover:border-nkf-gold hover:text-nkf-gold">Contact</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
